import { render } from "./Comprobantes.vue?vue&type=template&id=554ab5d4"
import script from "./Comprobantes.vue?vue&type=script&lang=js"
export * from "./Comprobantes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__